/**
 * ניווט משותף לפאנל — TASKS 3.2, 6.3ב · DESIGN.md 8.1.
 *
 * ⭐ `<nav aria-label>` נפרד מהניווט הראשי של האתר הציבורי (4.1) — שני הפאנלים
 *    לא יופיעו על אותו עמוד, אבל השם הייחודי חשוב לקוראי מסך בכל מקרה.
 *
 * ⭐ "הפריט הפעיל מסומן בקו תחתון נחושת 2px + משקל 500" (8.1) — `NavLink`
 *    במקום `Link` הרגיל, כדי לקבל את מצב ה-`isActive`.
 */
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button } from '../components/Button.js';
import { adminLogout, adminMe } from './adminApi.js';

const NAV_LINKS: ReadonlyArray<{ to: string; label: string; end?: boolean }> = [
  { to: '/admin', label: 'לוח בקרה', end: true },
  { to: '/admin/categories', label: 'קטגוריות' },
  { to: '/admin/products', label: 'מוצרים' },
  { to: '/admin/customers', label: 'לקוחות' },
  { to: '/admin/quotes', label: 'הצעות' },
  { to: '/admin/audit-log', label: 'יומן פעולות' },
];

export function AdminNav() {
  const navigate = useNavigate();
  const [demoPrices, setDemoPrices] = useState(false);

  // ⭐ TASKS 3.5 / PRD 14.3 — "באנר צהוב קבוע: מחירי הדגמה — יש להחליף לפני
  //    עלייה לאוויר". ⛔ הכישלון השקט המסוכן: מחירי הדגמה שנשארים בפרודקשן.
  //    `RequireAuth` כבר קרא ל-`/me` להרשאה — קריאה קטנה נוספת כאן שומרת על
  //    `AdminNav` עצמאי, בלי context משותף חדש למסך פאנל שכבר עובד.
  useEffect(() => {
    let cancelled = false;
    adminMe()
      .then((result) => {
        if (!cancelled && result) setDemoPrices(result.demoPrices);
      })
      .catch(() => {
        /* ⛔ כשל שקט בכוונה — RequireAuth כבר מטפל בניתוב אם אין סשן */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  async function handleLogout() {
    await adminLogout();
    navigate('/admin/login', { replace: true });
  }

  return (
    <>
      <nav
        aria-label="ניווט פאנל ניהול"
        className="border-line bg-canvas flex items-center gap-1 border-b px-6 py-3"
      >
        {NAV_LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `border-b-2 px-1 py-1 text-sm ${
                isActive ? 'text-link border-copper font-medium' : 'text-link border-transparent'
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
        <Button variant="secondary" className="ms-auto" onClick={() => void handleLogout()}>
          התנתקות
        </Button>
      </nav>
      {demoPrices && (
        <div role="status" className="banner-warning px-6 py-2 text-sm font-medium">
          מחירי הדגמה - יש להחליף למחירון האמיתי לפני עלייה לאוויר
        </div>
      )}
    </>
  );
}
